module.exports = __webpack_public_path__ + "static/media/trx.d986d6a2.svg";